"use strict";

import _ from "lodash";

class ObjectUtils {
  static pickDeep(/** Object **/ object, /** Array **/ props) {
    var result = {};

    _.forEach(props, function (path) {
      if (_.has(object, path)) {
        _.set(result, path, _.get(object, path));
      }
    });

    return result;
  }

  /**
   * Removes a property from an object if it has the property and it is empty
   * mutates the object
   * @param item
   * @param prop
   * @returns {*}
   */
  static cleanProp(/** Object **/ object, prop) {
    if (_.has(object, prop) && _.isEmpty(object[prop])) {
      _.unset(object, prop);
    }

    return object;
  }
}

export default ObjectUtils;
